import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import toast from "react-hot-toast";

function AddUser() {

    const navigate = useNavigate();

    const [roles, setRoles] = useState([]);

    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        password: "",
        role_id: "",
        status: "active"
    });

    useEffect(() => {
        loadRoles();
    }, []);

    const loadRoles = async () => {
        try {

            const res =
                await API.get(
                    "/admin/roles-dropdown"
                );
            

            setRoles(
                res.data
            );

        } catch (err) {

            console.log(err);

        }
    };

    const submit = async (e) => {

        e.preventDefault();

        try {

            await API.post(
                "/admin/users",
                form
            );

            toast.success(
                "User Added Successfully"
            );

            navigate(
                "/admin/users"
            );

        } catch (err) {

            console.log(err);

            toast.error(
                err.response?.data?.message ||
                "Failed to add user"
            );

        }

    };

    return (

        <div>

            <h1
                className="
                text-4xl
                font-bold
                mb-6
                "
            >
                Add User
            </h1>

            <form
                onSubmit={submit}
                className="
                bg-[#111]
                rounded-2xl
                p-6
                max-w-4xl
                "
            >

                <div
                    className="
                    grid
                    md:grid-cols-2
                    gap-5
                    "
                >

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Full Name
                        </label>

                        <input
                            type="text"
                            required
                            value={form.name}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    name: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="John Doe"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Phone
                        </label>

                        <input
                            type="text"
                            required
                            value={form.phone}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    phone: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="9876543210"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Email
                        </label>

                        <input
                            type="email"
                            required
                            value={form.email}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    email: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="user@email.com"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Password
                        </label>

                        <input
                            type="password"
                            required
                            value={form.password}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    password: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                            placeholder="********"
                        />

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Role
                        </label>

                        <select
                            required
                            value={form.role_id}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    role_id: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                        >

                            <option value="">
                                Select Role
                            </option>

                            {
                                roles.map(
                                    (role) => (
                                        <option
                                            key={role.id}
                                            value={role.id}
                                        >
                                            {role.role_name}
                                        </option>
                                    )
                                )
                            }

                        </select>

                    </div>

                    <div>

                        <label
                            className="
                            block
                            mb-2
                            font-semibold
                            "
                        >
                            Status
                        </label>

                        <select
                            value={form.status}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    status: e.target.value
                                })
                            }
                            className="
                            w-full
                            p-3
                            rounded-xl
                            bg-black
                            border
                            border-yellow-500/20
                            "
                        >
                            <option value="active">
                                Active
                            </option>

                            <option value="inactive">
                                Inactive
                            </option>

                        </select>

                    </div>

                </div>

                <div
                    className="
                    flex
                    gap-3
                    mt-8
                    "
                >

                    <button
                        type="submit"
                        className="
                        bg-yellow-500
                        text-black
                        px-8
                        py-3
                        rounded-xl
                        font-semibold
                        "
                    >
                        Save User
                    </button>

                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                "/admin/users"
                            )
                        }
                        className="
                        bg-gray-700
                        px-8
                        py-3
                        rounded-xl
                        "
                    >
                        Cancel
                    </button>

                </div>

            </form>

        </div>

    );

}

export default AddUser;